import { mergeAttributes, Node } from "@tiptap/core"

export interface PdfOptions {
	HTMLAttributes: Record<string, unknown>
}

declare module "@tiptap/core" {
	interface Commands<ReturnType> {
		pdf: {
			setPdf: (options: { src: string; fileName?: string }) => ReturnType
		}
	}
}

export const PdfExtension = Node.create<PdfOptions>({
	name: "pdf",
	group: "block",
	selectable: true,
	draggable: true,
	atom: true,

	addOptions() {
		return {
			HTMLAttributes: {},
		}
	},

	addAttributes() {
		return {
			src: {
				default: null,
			},
			fileName: {
				default: null,
				renderHTML: (attributes) => {
					if (!attributes.fileName) return {}
					return { title: attributes.fileName as string }
				},
				parseHTML: (element) => element.getAttribute("title"),
			},
			style: {
				default: "width:100%;aspect-ratio:4/3;border:0;",
				renderHTML: () => ({
					style: "width:100%;aspect-ratio:4/3;border:0;",
				}),
			},
		}
	},

	parseHTML() {
		return [
			{
				tag: "iframe[data-pdf]",
			},
			{
				tag: 'iframe[src$=".pdf"]',
			},
		]
	},

	renderHTML({ HTMLAttributes }) {
		return [
			"iframe",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
				"data-pdf": "true",
			}),
		]
	},

	addCommands() {
		return {
			setPdf:
				(options) =>
				({ commands }) => {
					return commands.insertContent({
						type: this.name,
						attrs: options,
					})
				},
		}
	},
})
